// Native camera. New shots use saveToGallery so Capacitor always keeps a copy in Photos.
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { isNativeApp } from "./platform";

const SOURCES = {
  prompt: CameraSource.Prompt,
  camera: CameraSource.Camera,
  photos: CameraSource.Photos,
};

/**
 * Native camera capture. Returns a webPath / dataUrl suitable for <img src>.
 * Throws if called outside Capacitor.
 */
export const takePhoto = async () => {
  if (!isNativeApp()) {
    throw new Error("takePhoto requires the native Capacitor app");
  }

  const photo = await Camera.getPhoto({
    quality: 85,
    allowEditing: false,
    resultType: CameraResultType.Uri,
    source: CameraSource.Camera,
    saveToGallery: true,
  });

  return photo.webPath || photo.path;
};

export const photoToFile = async (photo) => {
  const src = photo?.webPath;
  if (!src) throw new Error("No photo path");
  const res = await fetch(src);
  const blob = await res.blob();
  const ext = photo.format || "jpeg";
  const type = blob.type || `image/${ext}`;
  return new File([blob], `IMG_${Date.now()}.${ext}`, { type });
};

// Prompt = Take Picture / From Photos. Camera shots are written to the device gallery.
export const capturePhotoFile = async (kind = "prompt") => {
  if (!isNativeApp()) {
    throw new Error("capturePhotoFile requires the native Capacitor app");
  }

  const photo = await Camera.getPhoto({
    quality: 85,
    allowEditing: false,
    resultType: CameraResultType.Uri,
    source: SOURCES[kind] || CameraSource.Prompt,
    saveToGallery: true,
    promptLabelHeader: "Photo",
    promptLabelPhoto: "From Photos",
    promptLabelPicture: "Take Picture",
  });

  return photoToFile(photo);
};
